import { useState } from 'react';
import PropTypes from 'prop-types';
import { useForm, FormProvider } from 'react-hook-form';
import { InputControlled } from 'components/UI/InputControlled/InputControlled';
import { DropdownWithMenu } from 'components/UI/DropdownWithMenu/DropdownWithMenu';
import { yupResolver } from '@hookform/resolvers/yup';
import { deliveryAddressSchema } from 'utils/form-validation-schema';
import './PostalAddressForm.scss';
import { endpoints } from 'utils/global-constants';
import axios from 'axios';

export const PostalAddressForm = (props) => {
  const {
    states,
    shippingMethod,
    setSelectedAddress,
    setAddNewAddressIsOpen,
    setAddressSelection,
    setAddressChosenValue,
  } = props;
  const [processing, setProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [selectedState, setSelectedState] = useState(false);

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(deliveryAddressSchema),
  });

  const {
    formState: { isValid },
  } = methods;

  const onSubmitHandler = (data, e) => {
    setProcessing(true);

    const requestPayload = {
      deliveryData: {
        NewAddress: {
          AddressId: null,
          Street1: data.deliveryAddress1,
          Street2: data.deliveryAddress2,
          AddressLine3: null,
          Suburb: data.suburb,
          Postcode: data.postcode,
          StateId: null,
          State: selectedState,
          ReferenceStates: [],
          StateDescription: null,
          CountryId: null,
          PrimaryIndicator: null,
          CountryDescription: null,
          ShippingMethod: shippingMethod.toString(),
          ToBeDeleted: false,
          FullAddress: null,
          ErrorMessage: '',
        },
        SelectedDeliveryMethodID: shippingMethod.toString(),
        IsEligibleForDelivery: true,
      },
    };

    axios.post(endpoints.addDeliveryAddress, requestPayload).then((response) => {
      const errorMessageText = response?.data?.ErrorMessage;
      const result = response?.data;

      if (errorMessageText) {
        setErrorMessage(errorMessageText);
        setProcessing(false);
      } else {
        if (result.Redirect) {
          window.location.href = result.RedirectUrl;
        }

        setSelectedAddress(result.SelectedAddress);
        setProcessing(false);
        setAddNewAddressIsOpen(false);
        setAddressSelection(result.Addresses);
        setAddressChosenValue(result.SelectedAddress.FullAddress);
        e.target.reset();
      }
    });
  };

  const stateDropdownUpdateHandler = (stateCode) => {
    setSelectedState(stateCode);
  };
  const getDropDownOptions = () =>
    states.map((state) => ({
      key: state.StateCode,
      name: `${state.Description}`,
    }));

  return (
    <FormProvider {...methods}>
      <form
        name="expDeliveryDataForm"
        noValidate="novalidate"
        onSubmit={methods.handleSubmit(onSubmitHandler)}
      >
        <div className="form-group">
          <InputControlled type="text" id="deliveryAddress1" labelText="Address line 1" />
        </div>
        <div className="form-group">
          <InputControlled type="text" id="deliveryAddress2" labelText="Address line 2" />
        </div>
        <div className="form-group">
          <InputControlled type="text" id="suburb" labelText="Suburb" />
        </div>
        <div className="row">
          <div className="col-xs-6">
            <div className="form-group">
              <InputControlled
                type="text"
                id="postcode"
                labelText="Postcode"
                placeholderText="i.e. 3000"
              />
            </div>
          </div>

          <div className="col-xs-6">
            <div className="form-group">
              <div className="input-container">
                <DropdownWithMenu
                  singleColumn
                  dropdownChangeHandler={stateDropdownUpdateHandler}
                  defaultChosenValue="State"
                  menuData={getDropDownOptions()}
                  extendClass="select-state-dropdown"
                />
              </div>
            </div>
          </div>
        </div>

        <button
          type="submit"
          className="btn btn-secondary"
          disabled={!isValid || !selectedState || processing}
        >
          {processing ? <span>Processing...</span> : <span>Save and use this address</span>}
        </button>

        {errorMessage && (
          <div className="callout-container callout-error">
            Sorry! There was an error updating the Delivery address. Please try again.
          </div>
        )}
      </form>
    </FormProvider>
  );
};

PostalAddressForm.propTypes = {
  states: PropTypes.array,
  selectedStateDesc: PropTypes.string,
  newAddress: PropTypes.object,
  shippingMethod: PropTypes.number,
  setSelectedAddress: PropTypes.func,
  setAddNewAddressIsOpen: PropTypes.func,
  setAddressSelection: PropTypes.func,
  setAddressChosenValue: PropTypes.func,
};
